const fetchEvaluationsParams = ({ commit }, evaluationsParams) => {
  commit('setEvaluationParams', evaluationsParams);
};
const setEvaluation = ({ commit }, evaluation) => {
  commit('setEvaluation', evaluation);
};

export default {
  fetchEvaluationsParams,
  setEvaluation
};
